import React, { useEffect, useState } from 'react'
import { fetchListItems } from '../../../../../hooks/useCrud';
import LoaderAndError from '../../../../../components/LoaderAndError';
import DOMPurify from 'dompurify';
interface UiBasic {
  id?: number;
  apropos?: string;
  travail?: string;
  don?: string;
  structuregestion?: string;
  financement?: string;
  carriere?: string;
  partenariat?: string;
  createdAt?: string;
  updatedAt?: string;
}


interface Site {
  id?: number;
  nom?: string;
  description?: string;
  email?: string;
  adresse?: string;
  tel1?: string;
  tel2?: string;
  tel3?: string;
  token?: string;
  about?: string;
  mission?: string;
  objectif?: string;
  politique?: string;
  condition?: string;
  logo?: string;
  logoFile?: File;
  facebook?: string;
  linkedin?: string;
  twitter?: string;
  youtube?: string;
  whatsapp?: string;
  createdAt?: string;
  updatedAt?: string;
}
export default function Financement() {
  const [sites, setSites] = useState<Site[]>([]);
  const [basic, setBasic] = useState<UiBasic[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);


  const fetchListBasic = async () => {
    setLoading(true);
    try {
      const res = await fetchListItems<UiBasic>('/fetch_info_basic_data');
      setBasic(res.data);

      // console.log(res);
    } finally {
      setLoading(false);
    }

  }



  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await fetchListItems<Site>('/fetch_data_site');
      setSites(res.data);

      // console.log(res);
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    document.title = "Financement - Ouragan academy";
    fetchListBasic();
    fetchData();
  }, []);
  return (
    <div className="about-page-wrapper">
      {basic.length === 0 ? (
        <LoaderAndError
          loading={loading}
          error={error}
          onClearError={() => setError(null)}
        />
      ) : (
        basic.map((item, index) => (
          <div key={index}>

            {/* HERO */}
            <section className="py-5 text-center bg-light rounded">
              <h2 className="display-10 fw-bold mb-3">
                Sources de <span className="text-success">Financement</span>
              </h2>
              <p className="lead text-muted col-lg-8 mx-auto">
                Ouragan Academy se développe grâce à des mécanismes de financement
                transparents, durables et centrés sur l’impact social.
              </p>
            </section>

            {/* CONTENU DE LA BD */}
            <div className="container py-4">
              <div className="col-lg-10 mx-auto">
                <div
                  className="mb-4"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(item.financement ?? ""),
                  }}
                />
              </div>

              {/* BLOC SYNTHÉTIQUE */}
              <div className="row g-4 mt-2">

                <div className="col-md-4">
                  <div className="project-card shadow-sm rounded-4 border-0 h-100 overflow-hidden bg-white dark:bg-gray-900 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 p-4">
                    <i className="fas fa-donate text-success fs-1 mb-3"></i>
                    <h5 className="fw-bold">Dons & Sponsoring</h5>
                    <p className="text-muted">
                      Contributions de particuliers, entreprises et mécènes
                      soutenant la formation et l'encadrement des jeunes basketteurs.
                    </p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="project-card shadow-sm rounded-4 border-0 h-100 overflow-hidden bg-white dark:bg-gray-900 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 p-4">
                    <i className="fas fa-hand-holding-heart text-primary fs-1 mb-3"></i>
                    <h5 className="fw-bold">Partenaires & ONG</h5>
                    <p className="text-muted">
                      Appui institutionnel pour nos programmes psychosociaux,
                      éducatifs et sportifs dans les zones affectées par les conflits.
                    </p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="project-card shadow-sm rounded-4 border-0 h-100 overflow-hidden bg-white dark:bg-gray-900 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 p-4">
                    <i className="fas fa-project-diagram text-warning fs-1 mb-3"></i>
                    <h5 className="fw-bold">Projets & Subventions</h5>
                    <p className="text-muted">
                      Financements issus de projets sportifs et humanitaires, en
                      partenariat avec des institutions locales et internationales.
                    </p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        ))
      )}
    </div>


  )
}

